export default [
    {
        path: "products-tab",
        name: "LoyaltyProductsTab",
        meta:{
            permissionPath: 'products.read',
        },
        component: () =>
            import(
                /* webpackChunkName: "productsTab" */ "@/views/loyaltyPanel/products/tabs/ProductsTab.vue"
            )
    },

    {
        path: "products-per-store",
        name: "ProductsPerStore",
        meta:{
            permissionPath: 'products.read',
        },
        component: () =>
            import(
                /* webpackChunkName: "productsPerStore" */ "@/views/loyaltyPanel/products/tabs/ProductsPerStore.vue"
            )
    },

    {
        path: "products-series",
        name: "ProductsSeries",
        meta:{
            permissionPath: 'products.order',
        },
        component: () =>
            import(
                /* webpackChunkName: "productsSeries" */ "@/views/loyaltyPanel/products/tabs/ProductsSeries.vue"
            )
    },

    {
        path: "products-tags",
        name: "ProductsTags",
        meta:{
            permissionPath: 'products.tag.read',
        },
        component: () =>
            import(
                /* webpackChunkName: "productsTags" */ "@/views/loyaltyPanel/products/tabs/ProductsTags.vue"
            )
    }
];
